var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingLabRepotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.175,
    height: 24.063,
    viewBox: "0 0 27.175 24.063",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2520",
    "data-name": "Group 2520",
    transform: "translate(-579.9 -663.253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3335",
    "data-name": "Path 3335",
    d: "M624.621,677.458c0-3.834-6.961-13.358-6.961-13.358s-6.96,9.524-6.96,13.358a6.961,6.961,0,1,0,13.921,0Z",
    transform: "translate(-23.985 0)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_899",
    "data-name": "Line 899",
    x2: 6.252,
    transform: "translate(580.4 683.71)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_900",
    "data-name": "Line 900",
    x2: 21.569,
    transform: "translate(583.38 686.815)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_901",
    "data-name": "Line 901",
    x2: 3.96,
    transform: "translate(598.927 667.684)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_902",
    "data-name": "Line 902",
    x2: 9.128,
    transform: "translate(597.447 664.1)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3336",
    "data-name": "Path 3336",
    d: "M628.795,707.4a10.573,10.573,0,0,1-1.855,3.835A8.4,8.4,0,0,1,621,714.319a9.034,9.034,0,0,1-1.5-.042,5.712,5.712,0,0,0,10.837-2.522A11.513,11.513,0,0,0,628.795,707.4Z",
    transform: "translate(-30.952 -34.276)",
    fill: "#6c5b7b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingLabRepotIcon);
export default __webpack_public_path__ + "static/media/PendingLabRepotIcon.1f0708ac37e43a85476c5887eefab3b1.svg";
export { ForwardRef as ReactComponent };